// Material Kit 2 React pages
import Gallery from "pages/Gallery";

export default function GalleryPage() {
  return <Gallery />;
}
